import {makeAutoObservable} from "mobx";
import {SpecimenEntity} from "../entity/specimen-entity";
import {RcFile} from "antd/es/upload";
import {PageEntity} from "../entity/page-entity";
import {BaseLibraryEntity} from "../entity/base-library-entity";

export class SpecimenStore {
    constructor() {
        makeAutoObservable(this);
    }

    public condition: any = this.getDefaultCondition();
    public dataSource: SpecimenEntity[] = [];
    public selectRows: SpecimenEntity[] = [];
    public showBaseLibraryDetail:SpecimenEntity|undefined;
    public isShowDetail = false;
    public isShowEdit = false;
    public isShowUpload = false;
    public detailType: string = "add";
    public srcFile: any;
    public fileList: RcFile[] = [];
    public pagination:PageEntity = new PageEntity();
    public isShowDeleteCOnfirm = false;
    public deleteRecord!: SpecimenEntity;

    private getDefaultCondition() {
        return {
            specimenName: "", // 中文名
            specimenCanonicalName: "", //拉丁名
            gatherer: "",
            gatherDate: "",
            province: "",
            district: "",
            authenticateEr: "",
        };
    }

    public setDataSource(list: SpecimenEntity[]){
        this.dataSource = list;
    }


    public resetQueryCondition() {
        this.condition = this.getDefaultCondition();
    }

    public setSelectedRows(selectRows: SpecimenEntity[]){
        this.selectRows = selectRows;
    }

    public setBaseLibraryDetail(detail:SpecimenEntity) {
        this.showBaseLibraryDetail = detail;
    }

    public setShowDetail(isShow:boolean){
        this.isShowDetail = isShow;
    }

    public setShowEdit(isEdit:boolean){
        this.isShowEdit = isEdit;
    }

    public setShowUpload(isUpload:boolean) {
        this.isShowUpload = isUpload;
    }

    public clearSelectedRows(){
        this.selectRows = [];
    }

    public clearDetail = () => {
        this.showBaseLibraryDetail = undefined;
    }

    public setDetailType (type:string) {
        this.detailType = type;
    }

    public setSrcFile (srcfile: any) {
        this.srcFile = srcfile;
    }
    public setFilelist(file:RcFile) {
        this.fileList = [];
        this.fileList.push(file);
    }

    public clearFileList = () =>  {
        this.fileList = [];
    }

    public showDeleteConfirm(isShow:boolean){
        this.isShowDeleteCOnfirm = isShow;
    }

    public setDeleteRecord(record: SpecimenEntity) {
        this.deleteRecord = record;
    }

    public clear = () => {
        this.condition = this.getDefaultCondition();
        this.dataSource = [];
        this.selectRows = [];
        this.showBaseLibraryDetail = undefined;
        this.isShowDetail = false;
        this.isShowEdit = false;
        this.isShowUpload = false;
        this.srcFile = null;
        this.fileList = [];
        this.pagination = new PageEntity();
        this.isShowDeleteCOnfirm = false;
        this.deleteRecord = {} as SpecimenEntity;
    }
}